import { differenceInSeconds, formatDistanceToNow } from "date-fns";

const PHASE_COLORS = {
  Inoculation: "bg-gray-400",
  Colonization: "bg-amber-600",
  Pinning:      "bg-orange-500",
  Fruiting:     "bg-emerald-500",
  Harvesting:   "bg-sky-500",
};

const PHASE_COLORS_HEX = {
  Inoculation: "#9ca3af",
  Colonization: "#d97706",
  Pinning:      "#f97316",
  Fruiting:     "#10b981",
  Harvesting:   "#0ea5e9",
};

export { PHASE_COLORS, PHASE_COLORS_HEX };

export default function GrowPhaseBar({ phases = [], showLabel = true, labelClassName = "" }) {
  if (!phases.length) return null;

  const now = Date.now();
  const growStart = new Date(phases[0].started_at).getTime();
  const growEnd = new Date(phases[phases.length - 1].ended_at ?? now).getTime();
  const totalDuration = growEnd - growStart || 1;

  const currentPhase = phases.find(p => !p.ended_at);

  return (
    <div className="w-full">
      <div className="flex w-full h-3 rounded-full overflow-hidden gap-px">
        {phases.map((phase) => {
          const start = new Date(phase.started_at).getTime();
          const end = phase.ended_at ? new Date(phase.ended_at).getTime() : now;
          const width = ((end - start) / totalDuration) * 100;
          const color = PHASE_COLORS[phase.phase_name] ?? "bg-gray-300";
          return (
            <div
              key={phase.id}
              className={`${color} h-full`}
              style={{ width: `${Math.max(width, 2)}%` }}
              title={phase.phase_name}
            />
          );
        })}
      </div>
      {showLabel && currentPhase && (
        <div className={`text-xs text-gray-400 mt-1 w-fit ${labelClassName}`}>
          Day {Math.floor(differenceInSeconds(now, new Date(currentPhase.started_at)) / 86400) + 1} of {currentPhase.phase_name}
          {" · "}{formatDistanceToNow(new Date(phases[0].started_at), { addSuffix: false })} total
        </div>
      )}
    </div>
  );
}
